export default "__VITE_ASSET__BRPmdL0v__"